export class NativeStreamUpsertConfig {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "primaryKey",
            "baseName": "primaryKey",
            "type": "Array<string>",
            "format": ""
        },
        {
            "name": "deleteWhen",
            "baseName": "deleteWhen",
            "type": "string",
            "format": ""
        },
        {
            "name": "sequenceColumn",
            "baseName": "sequenceColumn",
            "type": "string",
            "format": ""
        },
        {
            "name": "dedup",
            "baseName": "dedup",
            "type": "NativeStreamDedupConfig",
            "format": ""
        },
        {
            "name": "keyIndexShards",
            "baseName": "keyIndexShards",
            "type": "number",
            "format": ""
        },
        {
            "name": "keyIndexScope",
            "baseName": "keyIndexScope",
            "type": "NativeStreamKeyIndexScope",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return NativeStreamUpsertConfig.attributeTypeMap;
    }
    constructor() {
    }
}
